import type { Company, User } from '@indutrust/shared-model';
import { type } from '@ngrx/signals';
import { eventGroup } from '@ngrx/signals/events';

/**
 * Authentication session events for user and company data management.
 *
 * These events manage the authenticated user's session state including
 * user data and company information.
 *
 * @example
 * const dispatch = injectDispatch(authSessionEvents);
 * dispatch.userDataRequested();
 */
export const authSessionEvents = eventGroup({
  source: 'auth.session',
  events: {
    authenticationInitialized: type<void>(),

    userDataRequested: type<void>(),
    userDataSucceeded: type<User>(),
    userDataFailed: type<{
      error: string;
    }>(),

    userCompanyRequested: type<string>(),
    userCompanySucceeded: type<Company>(),
    userCompanyFailed: type<{
      error: string;
    }>(),

    logoutRequested: type<void>(),
    logoutCompleted: type<void>(),
  },
});
